import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.5 6 1.75-1.75c1.2426-1.2427 3.2574-1.2427 4.5 0s1.2426 3.2573 0 4.5L18 10.5M13.5 6 3.2929 16.207A1 1 0 0 0 3 16.9142V21h4.0858c.2652 0 .5196-.1054.707-.2929L18 10.5M13.5 6l4.5 4.5"
    />
  </svg>
)
export default SvgPencil
